import { TextFieldProps } from '@material-ui/core/TextField';
import React, { useCallback, useState } from 'react';
import { useSubstate } from 'use-substate';

import { selectProducts } from 'core/Store/products/selectors';
import { Product } from 'core/types/product';

import Autocomplete from './Autocomplete';

const itemToString = (item?: Product) => (item ? item.name : '');

type Props = TextFieldProps & {
  value: number | null;
  place: number;
  onChange: React.ChangeEventHandler;
  name: string;
};

export default function SearchProducts({
  onChange,
  placeholder = 'Hae koolla tai nimellä',
  ...props
}: Props) {
  const [product, setProduct] = useState({} as Product);
  const [products] = useSubstate(selectProducts);

  const onSelect = useCallback(
    (item: any) => {
      setProduct(item);
      onChange({
        target: { name: props.name, value: item ? item.id : null }
      } as any);
    },
    [onChange, props.name]
  );

  const search = useCallback(
    (query: string) => {
      const data = products
        .filter(product => new RegExp(query, 'gi').test(product.name))
        .map(product => {
          return {
            payload: product,
            title: product.name,
            provider: product.id.toString()
          };
        });

      return Promise.resolve(data);
    },
    [products]
  );

  return (
    <Autocomplete
      {...props}
      placeholder={placeholder}
      onChange={onSelect}
      selectedItem={product}
      itemToString={itemToString}
      loading={false}
      search={search}
    />
  );
}
